module.exports = __webpack_public_path__ + "site/img/whatsen.38b3c3a0.png";